import { useState, useEffect } from "react";

//graphql
import { useQuery } from "@apollo/client";
import { GET_LOCATIONS } from "../../queries";

//material-ui
import { Alert, Autocomplete, FormControl, TextField } from "@mui/material";
interface SelectLocationProps {
	location: number | null;
	handleLocationChange: (location: number | null) => void;
}

const SelectLocation = ({ location, handleLocationChange }: SelectLocationProps) => {
	const { data, loading, error } = useQuery(GET_LOCATIONS);

	const [locations, setLocations] = useState<JobLocation[]>([]);
	const [selectedLocation, setSelectedLocation] = useState<JobLocation | null>(null);

	useEffect(() => {
		if (!loading && data && data.countcLocations) {
			setLocations(data.countcLocations);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [loading, data]);

	useEffect(
		() => {
			if (locations.length === 0) return;
			handleLocationChange(selectedLocation?.ID || 0);
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[selectedLocation]
	);

	useEffect(
		() => {
			if (locations.length === 0) return;
			if (location !== selectedLocation?.ID) {
				let loc = locations.find((l: JobLocation) => l.ID === location);
				setSelectedLocation(loc || null);
			}
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[location]
	);

	useEffect(
		() => {
			if (location) {
				let loc = locations.find((l: JobLocation) => l.ID === location);
				setTimeout(() => {
					setSelectedLocation(loc || null);
				}, 100);
			} else {
				setSelectedLocation(null);
			}
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[locations]
	);

	if (error) return <Alert severity="info">Locations Error: {error.message}</Alert>;

	if (loading) return <Alert severity="info">Loading...</Alert>;
	/*
	let selectOptions = locations.map((l: any, i: number) => {
		let locTrimed = l.Location.trimStart();
		let padlen = l.Location.length - locTrimed.length;
		let tt = "";

		return (
			<MenuItem style={{ whiteSpace: "pre" }} key={i} value={l.ID}>
				{(padlen > 1 ? tt.padStart(padlen - 2, "  ") : "") + (padlen > 0 ? "╰ " : " ") + locTrimed}{" "}
			</MenuItem>
		);
	});
	*/

	return (
		<FormControl fullWidth={true}>
			<Autocomplete
				disablePortal
				value={selectedLocation}
				id="location-select"
				options={locations}
				sx={{ width: 300 }}
				getOptionLabel={(option) => {
					let locTrimed = option.Location.trimStart();
					let padlen = option.Location.length - locTrimed.length;
					let tt = "";

					return (padlen > 1 ? tt.padStart(padlen - 2, "  ") : "") + (padlen > 0 ? "╰ " : " ") + locTrimed + " ";
				}}
				renderInput={(params) => <TextField {...params} label="Location" />}
				renderOption={(props, option) => {
					let locTrimed = option.Location.trimStart();
					let padlen = option.Location.length - locTrimed.length;
					let tt = "";
					let label = (padlen > 1 ? tt.padStart(padlen - 2, "  ") : "") + (padlen > 0 ? "╰ " : " ") + locTrimed + " ";
					return (
						<li {...props}>
							<span style={{ whiteSpace: "pre" }}>{label}</span>
						</li>
					);
				}}
				onChange={(e, v) => {
					setSelectedLocation(v);
				}}
			/>
		</FormControl>
	);
};

export default SelectLocation;
